module.exports = __webpack_public_path__ + "static/media/bus8.d6542260.jpg";